import { render, staticRenderFns } from "./DetailDoctor.vue?vue&type=template&id=655c1758&"
import script from "./DetailDoctor.vue?vue&type=script&lang=ts&"
export * from "./DetailDoctor.vue?vue&type=script&lang=ts&"
import style0 from "./DetailDoctor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports